export default __webpack_public_path__ + "static/media/cascade_failure.7c9f2281.svg";